<template lang="pug">
  main
    NavBarUsuarios
    Loader(v-show="isLoading")
    section.hero(v-show="!isLoading")
      .columns.has-text-centered
        .column.is-12
          .container
            h1.title Detalle de Usuario(a)
              | 
              a.button.is-dark.is-rounded(@click="backPage")
                i.fas.fa-times
            .columns.is-mobile.is-vcentered(v-show="!tieneDatos")
              .column.is-offset-one-fifths-desktop.is-three-fifth-desktop.is-offset-one-quarter-tablet.is-half-tablet.has-text-centered
                .notification.is-primary
                  button.delete
                  |   Aún no existen usuarios registrados.
      .columns.has-text-centered(v-show="tieneDatos")
        .column.is-offset-4.is-4
          .card
            .card-content
              .columns
                .column.is-12
                  h4.title.is-4
                    | {{ usuario.nombre }}
                  span(v-html="isJefeArea(usuario)")
                  br
                  span.tag.is-light 📌 {{ usuario.ubicacion}}
                  br
                  span.tag.is-light 📅 {{ usuario.fechaAlta}}
                  br
                  span 📪 
                    a(:href="usuario.email") {{usuario.email }}
              .columns.has-text-centered
                .column.is-12(v-if="usuario.avatar === ''")
                  span.tag.is-light Aún no tiene Firma
                  | &nbsp
                  br
                  
                .column(v-else)
                  figure.image.is-128x128.has-image-centered
                    img(:src="getAvatar(usuario.avatar)")
              .columns
                .column
                  a.button.is-warning Editar
                .column
                  a.button.is-dark.is-rounded(@click="verDropbox" v-show="!verDropBox")
                    | Anexar Firma &nbsp
                    i.fas.fa-chevron-down
                  a.button.is-light.is-rounded(@click="verDropbox" v-show="verDropBox")
                    | Ocultar Firma &nbsp
                    i.fas.fa-chevron-up
      .columns
        .column.is-offset-2.is-8
          Attachment(v-show="verDropBox" :usuarioSel="usuario" @actualizarPadre="obtenerData")
      .columns.column-blanco
</template>
<script>
  import usuariosServices from '../../services/usuarios/usuarios'
  import NavBarUsuarios from '@/components/usuarios_Componentes/layout/NavBarUsuarios.vue'
  import Loader from '@/components/shared/Loader.vue'
  import Attachment from '@/components/usuarios_Componentes/Attachment.vue'
  export default {
    name: 'usuario_Detalle',
    components: { NavBarUsuarios, Loader, Attachment },
    data () {
      return {
        usuario: {},
        tieneDatos: false,
        isLoading: true,
        verDropBox: false
      }
    },
    methods: {
      obtenerData () {
        const id = this.$route.params.id
        usuariosServices.getUsuario_Ind(id)
          .then(res => {
              this.isLoading = false
              this.usuario = this.convertirUser(res)
              this.verDropBox = false
            if (this.usuario.success) {
              this.tieneDatos = true
            } else {
              this.tieneDatos = false
            }
          })
      },
      convertirUser (user) {
        return {
          ...user,
          categoria: parseInt(user.categoria),
          departamento: parseInt(user.departamento),
          jefeArea: parseInt(user.jefeArea)
        }
      },
      isJefeArea (dataUser) {
        let deptoStr = ''
        let cargoStr = ''
        switch (dataUser.departamento) {
          case 0:
            deptoStr = `<span class="tag is-info">Administración</span>`
            break
          case 1:
            deptoStr = `<span class="tag is-warning">Instrumentación</span>`
            break
          case 3:
            deptoStr = `<span class="tag is-black">Sistemas y Telec.</span>`
            break
          case 4:
            deptoStr = `<span class="tag is-link">Operaciones</span>`
            break
          case 5:
            deptoStr = `<span class="tag is-success">Mantenimiento</span>`
            break
          case 6:
            deptoStr = `<span class="tag is-dark">Sist. e Inst.</span>`
            break
          case 7:
            deptoStr = `<span class="tag is-danger">Seguridad</span>`
            break
          case 8:
            deptoStr = `<span class="tag is-white">Externo</span>`
            break
          case 9:
            deptoStr = `<span class="tag is-white">Público</span>`
            break
        
          default:
            break
        }

        switch (dataUser.cargo) {
          case '000':
            cargoStr = `<strong>Gerente General</strong>`
            break
          case '001':
            cargoStr = `<strong>Gerente en Planta</strong>`
            break
          case '001':
            cargoStr = `<strong>Gerente de Administracion</strong>`
            break
          case '003':
            cargoStr = `<strong>Gerente GIA</strong>`
            break
          case '120':
            cargoStr = `<strong>Asistente de Gerencia</strong>`
            break
          case '160':
            cargoStr = `<strong>Asistente de Sistemas e Instrumentaciòn</strong>`
            break
          case '210':
            cargoStr = `<strong>Jefe de Instrumentación</strong>`
            break
          case '220':
            cargoStr = `<strong>Jefe de Administración</strong>`
            break
          case '2100':
            cargoStr = `<strong>Gerente Contraloria</strong>`
            break
          case '2120':
            cargoStr = `<strong>Asistente Finanzas</strong>`
            break
          case '2220':
            cargoStr = `<strong>Contador Sr.</strong>`
            break
          case '230':
            cargoStr = `<strong>Jefe de Sistemas y Telec.</strong>`
            break
          case '2320':
            cargoStr = `<strong>Analista de Cuentas por Pagar</strong>`
            break
          case '240':
            cargoStr = `<strong>Usuario Fiscalista</strong>`
            break
          case '241':
            cargoStr = `<strong>Jefe de Estación</strong>`
            break
          case '2420':
            cargoStr = `<strong>Jefe de Operaciones</strong>`
            break
          case '250':
            cargoStr = `<strong>Jefe de Mantenimiento</strong>`
            break
          case '2520':
            cargoStr = `<strong>Usuario Legal</strong>`
            break
          case '270':
            cargoStr = `<strong>Jefe de Seguridad</strong>`
            break
          case '300':
            cargoStr = `<strong>Usuario de Administración</strong>`
            break
          case '310':
            cargoStr = `<strong>Usuario de Instrumentación</strong>`
            break
          case '320':
            cargoStr = `<strong>Usuario de Administración</strong>`
            break
          case '321':
            cargoStr = `<strong>Empleado de Aduana</strong>`
            break
          case '323':
            cargoStr = `<strong>Auditor Operativo</strong>`
            break
          case '324':
            cargoStr = `<strong>Auditor Junior</strong>`
            break
          case '330':
            cargoStr = `<strong>Usuario de Sistemas y Telec.</strong>`
            break
          case '331':
            cargoStr = `<strong>Almacenista GIA</strong>`
            break
          case '332':
            cargoStr = `<strong>Almacenista Sistemas</strong>`
            break
          case '333':
            cargoStr = `<strong>Auditor</strong>`
            break
          case '340':
            cargoStr = `<strong>Usuario de Operaciones</strong>`
            break
          case '341':
            cargoStr = `<strong>Usuario de Facturación</strong>`
            break
          case '342':
            cargoStr = `<strong>Usuario de Báscula</strong>`
            break
          case '343':
            cargoStr = `<strong>Usuario de Báscula y Fact.</strong>`
            break
          case '344':
            cargoStr = `<strong>OPIB</strong>`
            break
          case '350':
            cargoStr = `<strong>Usuario de Mantenimiento</strong>`
            break
          case '370':
            cargoStr = `<strong>Usuario de Seguridad</strong>`
            break
          case '410':
            cargoStr = `<strong>Pasante de Instrumentación</strong>`
            break
          case '530':
            cargoStr = `<strong>Pasante de Sistemas</strong>`
            break
          case '7100':
            cargoStr = `<strong>Seguimiento Amb.</strong>`
            break
          case '7200':
            cargoStr = `<strong>Gerente Reg.</strong>`
            break
          case '7300':
            cargoStr = `<strong>Ing. de Proc. y Proc.</strong>`
            break
          case '880':
            cargoStr = `<strong>Usuario Propangol</strong>`
            break
          case '881':
            cargoStr = `<strong>Usuario Movenergy</strong>`
            break
          case '882':
            cargoStr = `<strong>Usuario Nieto</strong>`
            break
          case '883':
            cargoStr = `<strong>Usuario Metroplitano</strong>`
            break
          case '884':
            cargoStr = `<strong>Usuario Uribe</strong>`
            break
          case '885':
            cargoStr = `<strong>Usuario Mabarak</strong>`
            break
          case '886':
            cargoStr = `<strong>Usuario Sonigas</strong>`
            break
          case '888':
            cargoStr = `<strong>Jefe Of. Propangol</strong>`
            break
          case '990':
            cargoStr = `<strong>Usuario Público</strong>`
            break
        
          default:
            break
        }
        return `${cargoStr}<br/>${deptoStr}`
      },
      verDropbox () {
        this.verDropBox = !this.verDropBox
      },
      getAvatar (avatar) {
        let currentUrl = window.location.hostname
        return `https://${currentUrl}/reportesApp/${avatar}`
      },
      backPage () {
        this.$router.back()
      },
    },
    created () {
      this.obtenerData()
    },
  }
</script>

<style lang="css" scoped>
  .container {
    padding: 40px 0 0 0;
  }
  .column-blanco {
    padding-bottom: 120px;
  }
  .has-image-centered {
    margin-left: auto;
    margin-right: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/usuarios_Componentes/usuario_Detalle.vue